import React from 'react';

// @material-ui/icons components
import AccountBalanceWallet from '@material-ui/icons/AccountBalanceWallet';
import AttachFile from '@material-ui/icons/AttachFile';
import AddLocation from '@material-ui/icons/AddLocation';
import Receipt from '@material-ui/icons/Receipt';
import ChatBubbleOutline from '@material-ui/icons/ChatBubbleOutline';
import Add from '@material-ui/icons/Add';

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import timelineStyle from './timelineStyle';

import CommentBlock from './CommentBlock';

const icons = {
  addblock: { icon: Add, color: '#93CE85' },
  comment: { icon: ChatBubbleOutline, color: '#85BBCE' },
  qcd_admin_comment: { icon: ChatBubbleOutline, color: '#85BBCE' },
  treaty: { icon: Receipt, color: '#85BBCE' },
  payment: { icon: AccountBalanceWallet, color: '#85BBCE' },
  visit: { icon: AddLocation, color: '#85BBCE' },
  document: { icon: AttachFile, color: '#85BBCE' }
};

const Timeline = ({
  classes: c, data, onSendComment, onlyComment = false
}) => (
  <ul className={c.timeline}>
    <li className={c.item} key="commentBlock">
      <div className={c.badge} style={{ backgroundColor: icons.addblock.color }}>
        <icons.addblock.icon className={c.badgeIcon} />
      </div>
      <div className={c.itemContent} style={{ paddingBottom: 9 }}>
        <CommentBlock onlyComment={onlyComment} onSendComment={onSendComment} />
      </div>
    </li>
    {data.map((item, key) => {
      const CustomIcon = item.type ? icons[item.type].icon : null;
      const iconColor = item.type ? icons[item.type].color : '#ccc';

      return (
        <li className={c.item} key={key}>
          <div className={c.badge} style={{ backgroundColor: iconColor }}>
            <CustomIcon className={c.badgeIcon} />
          </div>
          <div className={c.itemContent}>
            <div>
              <span className={c.title}>{item.userName}</span>
              <span className={c.date}>{item._createdAt}</span>
            </div>
            {item.value ? (
              <h6 className={c.money}>+ {item.value} ₽</h6>
            ) : null}
            <div className={c.body}>{item.text}</div>
          </div>
        </li>
      );
    })}
  </ul>
);

export default withStyles(timelineStyle)(Timeline);



// WEBPACK FOOTER //
// ./src/components/MaterialDashboardPro/Timeline/Timeline.js